<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="4">
                  <ryou-input v-model="model.companyId" :value="model.companyId" :label="'会社ID'" v-show="false"></ryou-input>
                  <ryou-input v-model="model.companyName" :value="model.companyName" :label="'会社名'" :rules="inputRules" :maxlength="20"></ryou-input>
                  <!-- <v-text-field v-model="model.companyName" :value="model.companyName" :label="'会社名'">
                  </v-text-field> -->
                </v-col>
                <v-col cols="4">
                  <ryou-input v-model="model.companyCode" :value="model.companyCode" :label="'会社略称'" :rules="inputRules" :maxlength="20"></ryou-input>
                </v-col>
                <v-col cols="4">
                  <ryou-input v-model.number="model.companyNum" :value="model.companyNum" :label="'会社Num'" :rules="inputRules" :maxlength="20"></ryou-input>
                </v-col>
              </v-row>
              <v-row>
                <ryou-table ref="ryouTablePop" :rowKey="rowKey" :title="'ポップアップ一覧'" :headers="headers" :url="popUrl" :showSelect="true" :singleSelect="false" :businessKey="businessKey" :dummy="false">
                </ryou-table>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="handleOk">
            確認
          </v-btn>
          <v-btn color="blue darken-1" text @click="handleCancel">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  mixins: [RyouTableMixins],
  components: {
    RyouInput,
    RyouTable
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    dialog: false,
    title: "",
    valid: true,
    inputRules: [],
    model: {
      companyId: "",
      companyName: "",
      companyCode: "",
      companyNum: null
    },
    rowKey: "rowIndex",
    businessKey: "companyId",
    popUrl: {
      list: "/equipment/getCompany/"
    },
    tableName: "ryouTablePop",
    headers: [
      {
        text: "会社ID",
        value: "companyId",
        width: "10%",
        sortable: true,
        groupable: false
      },
      {
        text: "会社名",
        value: "companyName",
        width: "20%",
        sortable: true,
        groupable: false
      },
      {
        text: "会社略称",
        value: "companyCode",
        width: "200px",
        type: "text",
        sortable: true,
        groupable: false
      }
    ]
  }),
  methods: {
    add() {
      this.open();
      this.title = "会社マスタ新規";
    },
    edit(record) {
      this.open();
      this.title = "会社マスタ編集";
      setTimeout(() => {
        this.model = Object.assign({}, record);
      }, 10);
    },
    handleOk() {
      var valid = this.$refs.p1DialogForm.validate();
      if (valid) {
        var that = this;
        if (this.model.companyId) {
          let params = {
            companyId: this.model.companyId,
            companyName: this.model.companyName,
            companyCode: this.model.companyCode,
            companyNum: this.model.companyNum
          };
            this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then(resp => {
            if (resp.success) {
              that.$emit("ok");
            }
            that.close();
          });
        } else {
          let params = {
            companyName: this.model.companyName,
            companyCode: this.model.companyCode,
            companyNum: this.model.companyNum
          };
            this.postRequest(this.url.add, params, this.$store.getters.getUserToken).then(resp => {
            if (resp.success) {
              that.$emit("ok");
            }
            that.close();
          });
        }
      }

      // グリッドによって選択された結果セットをループさせると、親画面のデータを返します
      var temp = "";
      this.selectionRows.forEach(item => {
        temp += item.companyName + "\r\n";
      });
      this.$emit("setDataByChild", temp);
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;

      var that = this;
      setTimeout(() => {
        that.$refs.ryouTablePop.$on(
          "getSelectedRowKeys",
          this.getSelectedRowKeys
        );
        // // ポップアップ画面でグリッド検索のURLを変更します
        // that.$refs.ryouTablePop.url.list += localStorage.getItem("p1");
        // ポップアップ画面でグリッド検索処理を行う
        // that.$refs.ryouTablePop.loadData();
      }, 10);

      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    }
  }
};
</script>

<style>
</style>
